import type { WelcomeOfferNotificationData } from "~/core";

export const isWelcomeOfferNotification = (
  item: unknown,
): item is WelcomeOfferNotificationData => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "notification_welcome_offer"
  );
};
